import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import "./index.scss";

export const CartCardValue = ({ value, price }) => {
  return (
    <div className={"card-value"}>
      {value}{" "}
      <div className={"price-block"} data-testid="price-block">
        <span className={"for"}>for</span>&nbsp;
        <span className={"card-value__black"}>
          {toMoneyWithTwoDecimalDigits(price)}
        </span>
      </div>
    </div>
  );
};
